export const languagesBank = {
    languages: [],
    hasLanguages() {
        return this.languages.length > 0;
    },
    hasLanguage(lang) {
        return this.languages.indexOf(lang) !== -1;
    },
    enableLanguage(lang) {
        if (this.hasLanguage(lang)) {
            return;
        }

        this.languages.push(lang);
    }
};
